export default __webpack_public_path__ + "static/media/endGameBackground.7ec68ef3.svg";